import { Link } from "react-router-dom";
import { getOrgShortName } from "../../config";

export default function FooterPublic() {
    return (
        <footer className="text-muted mt-4 mb-3">
            <div className="container py-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                <div className="text-center text-md-start small">
                    &copy; {new Date().getFullYear()} {getOrgShortName()}. All rights reserved. <a style={{color: "#c90551", textDecoration: "none"}} href="https://surefirestack.com">Powered by Surefire Stack.</a>
                </div>
                <div className="d-flex gap-3 small">
                    <a href="/privacy" className="text-decoration-none link-secondary">Privacy</a>
                    <a href="/terms" className="text-decoration-none link-secondary">Terms</a>
                    <a href="/contact" className="text-decoration-none link-secondary">Contact</a>
                    <a href="/press-releases" className="text-decoration-none link-secondary">Press Releases</a>
                </div>
            </div>
        </footer>
    );
}